export default __webpack_public_path__ + "images/H2.d271742.png";